import { useEffect, useRef, useState } from 'react';
import { getDispatchListHistory, getDriverDropoffHistory, getScanBatchReports, quickTransferOrders, setScanBatchStatus, updateScanStatus } from '../../../actions/ddActions';
import { useDispatch, useSelector } from 'react-redux';
import { handleEditOrderModal, showAlertSnackbar } from '../../../reducers/uiSlice';
import EditOrderModal from '../../EditOrderModal';
import UniDialog from "../../Common/UniDialog";
import { makeStyles, MenuItem, Typography } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { getCurrentWarehouse, getUserPreference, handleTextualizeDriverNameAndVehicleType } from '../../../utilities/common';
import { getLetianStaff, getLetianStaffTemp } from '../../../actions/qtActions';
import _ from 'lodash';
import { updateDispatchSummary } from '../../../actions/ddActions';
import moment from "moment";
import { nextTransitionSubmit, updateShippingStatusSimple } from '../../../actions/editOrderActions';
import FullscreenLoading from '../../Common/FullscreenLoading';
import SubdirectoryArrowRightIcon from '@material-ui/icons/SubdirectoryArrowRight';
import { getStaffList } from '../../../actions/mmActions';

const useStyle = makeStyles((theme) => ({
    stateStyle: {
        marginLeft: 10
    },
    notesGroupStyle: {
        display: 'flex',
        alignItems: 'baseline',
        marginLeft: 50
    },
    notesStyle: {
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
        maxWidth: 600
    },
    menuItemStyle: {
        display: 'flex',
        alignItems: 'center'
    }
}))

function DriverTransfer(props) {
    const classes = useStyle();
    const {t} = useTranslation('driverDispatch');
    const dispatch = useDispatch();

    const userPref = getUserPreference();

    const NEXT_TRANSITION_STAFF_ID = 666;
    const INITIAL_ALL_CHECKED = () => {
        return {
            'all': {
                checked: false
            },
            '202': {
                checked: false
            },
            '203': {
                checked: false
            }
        }
    };

    const searchList = useSelector(state => state.ddReducer.getLetianStaff);
    const driverIdSearch = useSelector(state => state.ddReducer.driverId);

    const [open, setOpen] = useState(false);
    const [list, setList] = useState([]);
    const [isChecked, setIsChecked] = useState([]);
    const [allChecked, setAllChecked] = useState(INITIAL_ALL_CHECKED);
    const [transferDriverName, setTransferDriverName] = useState('');
    const [transferDriverId, setTransferDriverId] = useState('');
    const [editOrderModalOpen, setEditOrderModalOpen] = useState(false);
    const [tno, setTno] = useState('');
    const [driverListTemp, setDriverListTemp] = useState([]);
    const [referer, setReferer] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const toggleCheckboxValue = (order, referer) => {
        if(referer) {
            setReferer(referer);
        }
        let isCheckedCopy = _.cloneDeep(isChecked);
        let exist = false;
        if(isChecked.length > 0) {
            const index = isChecked.findIndex(object => {
                return object.order_id === order.order_id;
            });
            if(index !== -1) {
                isCheckedCopy.splice(index, 1);
                exist = true;
            }
        }
        if(!exist) {
            isCheckedCopy.push(order);
        }
        setIsChecked(isCheckedCopy);
    }
    const handleProcess = async(params) => {
        let paramsScan = {
            tracking_no: params?.parcel_info?.extra_order_sn,
            scan_batch_id: props.scanBatchId
        }
        await dispatch(updateScanStatus(paramsScan))
        .catch((err) => {
            if(err.status === 403) {
                dispatch(showAlertSnackbar({message: err?.data?.biz_message, type: 'warning'}))
            } else {
                dispatch(showAlertSnackbar({message: t('api_fail'), type: 'warning'}))
            }
        })
    }

    useEffect(() => {
        if(props.open) {
            setOpen(true);
            setTransferDriverName('...');
            if(userPref.userCity === 2 || userPref.userCity === 14) {
                dispatch(getLetianStaffTemp(userPref.userCity))
                .then((res) => {
                    setDriverListTemp(res);
                })
            }
            setIsChecked([]);
            setAllChecked(INITIAL_ALL_CHECKED);
        } else {
            setOpen(false);
            setTransferDriverName('...');
        }
    }, [props.open])
    useEffect(() => {
        if(props.type === 'driver_dispatch') {
            props.rows.map((row) => {
                if(row.driver_id === props.driverId && row.id === props.transferId) {
                    if(props.listCate === 'total_returned' && row.return_order_list) {                   
                        setList(row.returnOrders);
                    } else if(props.listCate === 'total_transfered' && row.transferOrders) {
                        setList(row.transferOrders);
                    } else if(props.listCate === 'total_unscanned' && row.unscanOrders) {
                        setList(row.unscanOrders);
                    } else {
                        setList([]);
                    }                              
                }
            })
        }
        setAllChecked(INITIAL_ALL_CHECKED);
    }, [props.driverId, props.rows, props.listCate, props.transferId, props.type])
    useEffect(() => {
        if(props.type !== 'driver_dispatch') {
            setList(props.list);
            setIsChecked([]);
            setAllChecked(INITIAL_ALL_CHECKED);
        }
    }, [props.list, props.type])
    // useEffect(() => {
    //     if(isChecked) {
    //         if(isChecked.length <= 0) {
    //             setIsChecked([]);
    //         }
    //     }
    // }, [isChecked])
    useEffect(() => {
        if(props.criteria === 'UNSCANNED') {
            if(allChecked['all'].checked && allChecked['202'].checked && allChecked['203'].checked) {
                let orderChecked = list.map((order) => {
                    return {
                        order_sn: order.extra_order_sn || order.tno,
                        order_id: order.order_id
                    }}
                )
                setIsChecked(orderChecked);
            } else if(!allChecked['all'].checked && !allChecked['202'].checked && !allChecked['203'].checked) {
                setIsChecked([]);
            } else {
                let orderChecked = [];
                list.filter((order) => {
                    if(
                        (allChecked['203'].checked && order.state === 203)
                        ||
                        (allChecked['202'].checked && order.state === 202)
                        ||
                        (allChecked['all'].checked && order.state !== 202 && order.state !== 203)
                    ) {
                        orderChecked.push({
                            order_sn: order.extra_order_sn || order.tno,
                            order_id: order.order_id
                        });
                    }
                });
                setIsChecked(orderChecked);
            }
        } else {
            if(allChecked['all'].checked) {
                let orderChecked = list.map((order) => {
                    return {
                        order_sn: order.extra_order_sn || order.tno,
                        order_id: order.order_id
                    }}
                )
                setIsChecked(orderChecked);
            } else {
                setIsChecked([]);
            }
        }
    }, [allChecked])

    function handleClose() {
        setOpen(false);
        props.handleClose(false);
    }
    function handleEditModalClose() {
        setEditOrderModalOpen(false);
    }
    function toggleAllCheckboxValues(state) {
        if(props.criteria === 'UNSCANNED') {
            if(state === 'all') {
                // ALL checked => 202 checked and 203 checked
                if(!allChecked[state].checked) {
                    setAllChecked({
                        'all': {
                            checked: true
                        },
                        '202': {
                            checked: true
                        },
                        '203': {
                            checked: true
                        }
                    });
                } else {
                    // ALL unchecked => 202 unchecked and 203 unchecked
                    setAllChecked({
                        'all': {
                            checked: false
                        },
                        '202': {
                            checked: false
                        },
                        '203': {
                            checked: false
                        }
                    });
                }
                return;
            }
        }
        // Other conditions
        setAllChecked(prevState => ({
            ...prevState,
            [state]: {
                checked: !allChecked[state].checked
            }
        }));
    }
    function handleCopy() {
        let selectedOrdersCurr = '';
        if(isChecked.length > 0) {
            isChecked.map((order) => {
                selectedOrdersCurr = selectedOrdersCurr.concat('\n' + order.order_sn);
            })
        }
        selectedOrdersCurr = selectedOrdersCurr.substring(1);
        navigator.clipboard.writeText(selectedOrdersCurr.toString())
        dispatch(showAlertSnackbar({title: 'Copy Batch', message: t('copy_success'), type: 'success'}))
    }
    function handleSubmit() {
        setIsLoading(true);
        let params = {
            tnos: _.map(isChecked, 'order_sn').toString(),
            driver_id: transferDriverId,
            operator: userPref.username
        }
        dispatch(quickTransferOrders(params))
        .then((res) => {
            if(res.order_not_found.length === 0){
                //All are transferred
                dispatch(showAlertSnackbar({
                    title: "Transferred Successful!",
                    message: `All ${res.success.length} orders are transferred`,
                    type: 'success'
                }))
            } else {
                dispatch(showAlertSnackbar({
                    title: "Transferred Partially Successful!",
                    message: `Failed: ${res.order_not_found}`,
                    type: 'warning'
                }))
            }
            let paramsNoDate = {
                warehouse: userPref.userCity,
                driver_id: driverIdSearch
            }
            if(props.type === 'pickup_scan_report') {
                dispatch(getScanBatchReports(paramsNoDate))
                .finally(() => {
                    setIsLoading(false);
                })
            } else {
                dispatch(showAlertSnackbar({message: t('search_again'), type: 'success'}))
            }
            props.handleClose();
        })
        .catch((error) => {
            dispatch(showAlertSnackbar({
                title: "Transferred Failed!",
                message: error.message
            }))
        })
        .finally(() => {
            setIsLoading(false);
        })
    }
    function handleEditOrderModalOpen(tno) {
        setTno(tno);
        dispatch(handleEditOrderModal({open: true}));
    }
    async function handleUpdateStatusSummary(paramsList) {
        try {
            await dispatch(setScanBatchStatus(props.scanBatchId, 'REOPEN'));
            await Promise.all(paramsList.map(async(params) => {
                await handleProcess(params);
            }))
            await dispatch(setScanBatchStatus(props.scanBatchId, 'PRECLOSE'));
            await dispatch(setScanBatchStatus(props.scanBatchId, 'REVIEW'));
            let paramsNoDate = {
                warehouse: userPref.userCity,
                driver_id: driverIdSearch
            }
            if(props.type === 'pickup_scan_report') {
                await dispatch(getScanBatchReports(paramsNoDate))
            } else {
                await dispatch(showAlertSnackbar({message: t('search_again'), type: 'success'}))
            }
        } catch(err) {
            dispatch(showAlertSnackbar({message: err?.data?.biz_message || t('set_scan_error'), type: 'error'}))
        } finally {
            setIsLoading(false);
        }
    }
    function handleUpdateDispatchSummary() {
        handleClose();
        setIsLoading(true);
        const currentBranch = getCurrentWarehouse();
        let paramsList = [];
        isChecked.map((order, index) => {
            paramsList.push({
                staff_id: NEXT_TRANSITION_STAFF_ID,
                scan_location: currentBranch.name,
                storaged_warehouse: currentBranch.id,
                send_sms: 0,
                shipping_status: 1,
                exception: null,
                order_id: order.order_id,
                parcel_info: {
                    extra_order_sn: isChecked[index].order_sn,
                    transition: 'PARCEL_SCAN',
                    order_id: order.order_id,
                    status: 200,
                    desc: '',
                    warehouse: currentBranch.id
                }
            });
        })
        handleUpdateStatusSummary(paramsList);
    }

    useEffect(() => {
        if(!searchList?.length > 0) {
            dispatch(getStaffList())
            .catch(() => {
                dispatch(showAlertSnackbar({message: t('common:fetch_data_fail'), type: 'error'}))
            })
        }
    }, [])

    return (
        <>
            <EditOrderModal 
                open={editOrderModalOpen} 
                tno={tno} 
                onClose={handleEditModalClose} 
                handleClose={handleEditModalClose} 
                byResendOrder={true} 
            />
            <UniDialog
                maxWidth='md'
                fullWidth
                disableDefaultButtons
                open={open}
                onClose={handleClose}
            >
                <div>
                    <div style={{display: 'flex', alignItems: 'space-between'}}>
                        <MenuItem onClick={()=>toggleAllCheckboxValues('all')}>
                            <Checkbox checked={allChecked['all'].checked}></Checkbox>
                            <span>{t('select_all')}</span>
                        </MenuItem>
                        {   props.criteria === 'UNSCANNED' &&
                            <MenuItem onClick={()=>toggleAllCheckboxValues('202')}>
                                <Checkbox checked={allChecked['202'].checked}></Checkbox>
                                <span>{t('select_all_202')}</span>
                            </MenuItem>
                        }
                        {   props.criteria === 'UNSCANNED' &&
                            <MenuItem onClick={()=>toggleAllCheckboxValues('203')}>
                                <Checkbox checked={allChecked['203'].checked}></Checkbox>
                                <span>{t('select_all_203')}</span>
                            </MenuItem>
                        }
                        <Button 
                            color="secondary"
                            onClick={handleCopy}
                        >
                            {t('copy')}
                        </Button>
                    </div>
                    {
                        list &&
                        list.length > 0 &&
                        list.map((order, index) => {
                            return (
                                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                    <MenuItem 
                                        value={order.extra_order_sn||order.tno} 
                                        key={index} 
                                        onClick={() => toggleCheckboxValue({order_sn: order.extra_order_sn||order.tno, order_id: order.order_id}, order.referer)}
                                        style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}
                                    >
                                        <div
                                            className={classes.menuItemStyle}
                                        >
                                            <Checkbox 
                                                key={index} 
                                                checked={isChecked.some(item => item.order_sn === order.extra_order_sn)}
                                                id={`driverdispatch-drivertransfer-checkbox-${index}`}
                                            >
                                            </Checkbox>
                                            <div 
                                                style={order.state===203 ? {backgroundColor: 'green'} : (order.state===202 ? {backgroundColor: 'orange'} :{backgroundColor: 'transparent'})}  
                                            >
                                                <div>{order.extra_order_sn||order.tno}</div>
                                            </div>
                                            {
                                                order.state &&
                                                <div 
                                                    className={classes.stateStyle}
                                                    style={order.state===203?{color: 'green'}:(order.state===202?{color: 'orange'}:{color: 'white'})}
                                                >
                                                    {order.state}
                                                </div>
                                            }
                                        </div>
                                        {
                                            order?.driver_notes &&
                                            <div
                                                className={classes.notesGroupStyle}
                                            >
                                                <SubdirectoryArrowRightIcon />
                                                <div className={classes.notesStyle}>
                                                    {order.driver_notes}
                                                </div>
                                            </div>
                                        }
                                    </MenuItem>
                                    <Button 
                                        color="secondary" 
                                        onClick={()=>{
                                            handleEditOrderModalOpen(order.extra_order_sn||order.tno)
                                        }}
                                        style={{marginTop:10}}
                                    >
                                        {t('edit')}
                                    </Button>
                                </div>                               
                            )
                        })
                    }
                    {
                        props.criteria === 'UNSCANNED' &&
                        <div style={{width:'100%',textAlign: 'center',marginTop:20}}>
                            <Button
                                color='primary'
                                variant='contained'
                                disabled={isChecked.length<=0 || props.scanBatchStatus!==1}
                                onClick={handleUpdateDispatchSummary}
                                id='driverdispatch-drivertransfer-confirmscan-button'
                            >
                                {t('confirm_scanned')}
                            </Button>
                        </div>
                        
                    }
                    {
                        props.type !== 'dropoff_list' &&
                        <div style={{ marginTop: 20 }}>
                            <div>
                                <span>{t('transfer_to')}</span>
                                <span style={{ marginLeft: 10 }}>{transferDriverName}</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                <TextField 
                                    variant="outlined" 
                                    style={{ marginRight: 10, width: '60%' }}
                                    placeholder={t('driver_id')}
                                    onChange={(e)=>{
                                        setTransferDriverName(handleTextualizeDriverNameAndVehicleType(e.target.value, userPref.userCity, driverListTemp, searchList));
                                        setTransferDriverId(e.target.value);
                                    }}
                                />
                                <Button 
                                    variant='contained' 
                                    color="secondary" 
                                    style={{ width: '40%' }}
                                    onClick={handleSubmit}
                                    disabled={!transferDriverName || transferDriverName === '...'}
                                    id='driverdispatch-drivertransfer-button'
                                >{t('submit')}</Button>
                            </div>
                        </div>
                    }
                </div>
            </UniDialog>
            <FullscreenLoading open={isLoading}/>
        </>
    );
}

export default DriverTransfer;